/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactsintro1Inputs */

const en_artifactsintro1 = /** @type {(inputs: Artifactsintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each artifact is generated only when you click. Nothing is ever sent on your behalf — you decide.`)
};

const pt_artifactsintro1 = /** @type {(inputs: Artifactsintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada documento é gerado apenas quando clica. Nada é enviado em seu nome — a decisão é sua.`)
};

/**
* | output |
* | --- |
* | "Each artifact is generated only when you click. Nothing is ever sent on your behalf — you decide." |
*
* @param {Artifactsintro1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactsintro1 = /** @type {((inputs?: Artifactsintro1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactsintro1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactsintro1(inputs)
	return pt_artifactsintro1(inputs)
});
export { artifactsintro1 as "artifactsIntro" }